import { useState } from 'react';
import UserStoryPointChart from './UserStoryPointChart';
import ProjectSprintCard from './ProjectSprintCard';
import ProjectTeamCard from './ProjectTeamCard';
import {SkeletonChart, SkeletonTable} from './SkeletonLoader';
import { useSprintData } from '@/hooks/useSprintData';
import Header from './Header';
import ViewSelector from './ViewSelector';
import Card from './Card';

export default function SprintPlanning() {
  const { sprints, isLoading, updateMessage, fetchData } = useSprintData();
  const [activeView, setActiveView] = useState('user'); // 'user', 'project', or 'projectSprint'

  if (isLoading) {
    return (
      <>
        <Header />
        <div className="container mx-auto p-4">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold">Sprint Resource Planning</h1>
          </div>
          <div className="grid grid-cols-1 gap-6">
            <SkeletonChart />
            <SkeletonTable />
          </div>
        </div>
      </>
    );
  }
  
  if (sprints.length === 0) {
    return (
      <>
        <Header />
        <div className="container mx-auto p-4">
          <div className="text-center p-8">
            <p>No sprint data available.</p>
          </div>
        </div>
      </>
    );
  }

  const handleUpdate = async () => {
    await fetchData();
  };

  return (
    <>
      <Header />
      <div className="container mx-auto p-4">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Sprint Resource Planning</h1>
          <div className="flex items-center">
            {updateMessage && (
              <span className="text-green-600 mr-4">{updateMessage}</span>
            )}
            <button
              onClick={handleUpdate}
              disabled={isLoading}
              className="px-4 py-2 bg-primary hover:opacity-90 text-white rounded-md flex items-center cursor-pointer"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 mr-2 ${isLoading ? 'animate-spin' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              {isLoading ? 'Updating...' : 'Update Data'}
            </button>
          </div>
        </div>
        
        <>
          <Card 
            title="Story Points Distribution"
            action={
              <ViewSelector 
                activeView={activeView}
                onViewChange={setActiveView}
                options={[
                  { id: 'user', label: 'User View' },
                  { id: 'project', label: 'Project View' },
                  { id: 'projectSprint', label: 'Teams per Sprint' }
                ]}
              />
            }
          >
            {activeView === 'user' && <UserStoryPointChart viewMode="user" hideToggle={true} />}
            {activeView === 'project' && <UserStoryPointChart viewMode="project" hideToggle={true} />}
            {activeView === 'projectSprint' && <ProjectSprintCard />}
          </Card>
          
          {/* Always show the project team card */}
          <ProjectTeamCard />
        </>
      </div>
    </>
  );
}